<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm"
	*ngIf="UserModuleAccess==='Full'">
	<div class="row mb-3">
		<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
			<mat-form-field appearance="fill">
				<mat-label>Name</mat-label>
				<input matInput placeholder="" formControlName="name" id="name">
			</mat-form-field>
			<p *ngIf="showError('name')" class="field-error">
				<mat-error *ngIf="f.name.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</mat-error>
			</p>
		</div>
		<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
			<!-- <mat-form-field appearance="fill">
				<mat-label>Description</mat-label>
				<input matInput placeholder="" formControlName="description" id="description">
			</mat-form-field> -->
			<mat-form-field appearance="fill">
				<textarea matInput formControlName="description" id="description" class="materialize-textarea" data-length="120"></textarea>
				<mat-label>Description</mat-label>
			</mat-form-field>
			<p *ngIf="showError('description')" class="field-error">
				<mat-error *ngIf="f.description.errors?.required">
					Required
				</mat-error>
				<mat-error *ngIf="f.description.errors?.pattern">
					Invalid
				</mat-error>
				<mat-error *ngIf="f.description.errors?.incorrect">
					{{customError.description}}
				</mat-error>
			</p>
		</div>
	</div>
	
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>